export default __webpack_public_path__ + "static/media/94.4bd72da2.png";